import { GetReadyToInvoiceJobsRequest } from '../../../domain/invoicing/invoicingApi'
import { FilterCategory, FiltersState } from '../InvoiceByJob/filtersModel'

const selectedValues = (category?: FilterCategory) =>
  !category || category.all ? undefined : category.values.filter(value => value.selected).map(value => value.value)

export const readyToInvoiceRequest = (filters: FiltersState): GetReadyToInvoiceJobsRequest => ({
  startDate: filters.dateRange.starting,
  endDate: filters.dateRange.ending,
  divisionGroups: selectedValues(filters.divisions) as string[] | undefined,
  workAreaStatuses: selectedValues(filters.scheduledStatus) as number[] | undefined,
  jobTypes: selectedValues(filters.projectType) as number[] | undefined,
  visitReviewStatuses: selectedValues(filters.visitReviewStatus) as number[] | undefined,
  search: filters.search,
})

export const DATE_HELP = 'Shows jobs with visits dated in this range. Invoices created from this list include work through the end date.'
